import generic from './generic'

const getDefaultState = () => {
  return {
    all: [],
    errored: false,
    loading: false,
    fetchedAt: null,
    next: null,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {type: 'evidence'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {type: 'evidence', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
  filterForParticipant: (state) => (participant) => {
    return state.all.filter(obj => obj.participant === participant.id)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
